import { DependsOnIfEnum } from "@generation/schema-core/src/client/enums/dependsOnIfEnum";
import { DependsOnThenEnum } from "@generation/schema-core/src/client/enums/dependsOnThenEnum";
import { IDependsOn } from "@generation/schema-core/src/client/model/dependsOn";
import { voorWieSteltUDeVraagProp } from "../utils/contactFormulierProps";
import { voorIemandAndersDieKlantIsOptie } from "../utils/voorWieSteltUDeVraagOptions";

export const dependsOnShowIfIemandAnders: IDependsOn[] = [
  {
    property: voorWieSteltUDeVraagProp,
    if: DependsOnIfEnum.IsNotEqualToValue,
    value: voorIemandAndersDieKlantIsOptie,
    then: DependsOnThenEnum.Hide,
    isAbsolutePath: true
  }
];
